<template>
    <div>
        <question :text="$t(item.text)" />
        <b-row align-h="center" class="mb-3">
            <b-col cols="12" sm="10" md="8">
                <select-input
                    class="w-100"
                    :options="selectOptions"
                    :max="max"
                    :min="min"
                    @select="handleSelect"
                />
                    <div v-if="otherOptionChecked">
                        <text-input
                            @change="handleChange"
                            :validator="validate"
                            :error-text="errorText"
                            :placeholder="$t(`${item.text}_OTHER_TEXT_TITLE`)"
                        />
                    </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { ASSETS_URL } from '@/constants/misc'
import { CHOICE_RESULTS } from '@/constants/items'
import { getChoiceLabel } from '@/utils/items'

import selectInput from '@/components/inputs/select'
import textInput from '@/components/inputs/text'
import question from '@/components/ui/question'

export default {
    name: 'multiChoiceItem',
    components: {
        question,
        selectInput,
        textInput
    },
    props: {
        item: {
            type: Object
        },
        itemProperties: {
            type: Object
        },
        minLength: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            results: null,
            text: null,
            otherOptionChecked: false,
        }
    },
    computed: {
        selectOptions() {
            return this.item.choices.map(choice => {
                return {
                    order: choice.order,
                    value: choice.result,
                    label: this.$t(choice.text),
                    icon: getChoiceLabel(choice, 'ICON') && ASSETS_URL + this.$t(getChoiceLabel(choice, 'ICON').text)
                }
            })
        },
        max() {
            const max = this.itemProperties.getProperty('multi_choice_max')
            return max ? parseInt(max) : 1
        },
        min() {
            const min = this.itemProperties.getProperty('multi_choice_min')
            return min ? parseInt(min) : 1
        },
        errorText() {
            return this.$t(`${this.item.text}_TEXT_VAL_ERROR`)
        },

    },
    methods: {
        validate(input) {
            if(!input) return false
            return input.length >= this.minLength
        },
        answer() {
            const data = this.otherOptionChecked && this.text ? {
                key: 'OTHER',
                value: this.text
            } : undefined

            if(data) {
                this.results[this.results.length-1]['data'] = [data]
            }

            this.$emit('answer', this.results)
        },
        handleSelect(values) {
            const options = this.selectOptions.map(option => ({
                result: values.indexOf(option.value) !== -1 ? CHOICE_RESULTS.TRUE : CHOICE_RESULTS.NONE,
                choice: option.value,
            }))


            // if we have last option checked in values we show text input field
            const last = this.selectOptions[this.selectOptions.length-1]
            const includesLast = options && options.find(choice => choice.choice === last.value).result === 1
            this.otherOptionChecked = includesLast

            if(values.length >= this.min && values.length <= this.max) {
                this.results = options

                // extra validation for text
                if(!this.otherOptionChecked || (this.otherOptionChecked && this.validate(this.text))) {
                    this.answer()
                } else {
                    this.$emit('answer', null)
                }
            } else {
                this.$emit('answer', null)
            }
        },
        handleChange(text) {
            this.text = text
            if(this.validate(this.text)) {
                this.answer()
            } else {
                this.$emit('answer', null)
            }
        }
    },

}
</script>
<style lang="scss">
.multi-choice-other__text {
    height: 100px;
}
</style>